import {Component, EventEmitter, Output, Input, OnInit} from '@angular/core';
import { Router } from "@angular/router";
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import { Observable , Subscription } from 'rxjs';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { EventBusService } from '@signature-it/ngx-generic/services';
import { EventData, EventName} from '@signature-it/ngx-generic/classes';
import { AddToSuccessModalComponentGeneric } from '@signature-it/ngx-catalogue/components/success-modal';
import { getProcessingAddToCart, getAddToCartOpenModal, getRedirectLink, getSkipModalAfterAddToCart, getAddToCartError } from '@signature-it/ngx-catalogue/store/selectors';
import { CartActions } from '@signature-it/ngx-catalogue/store/actions';

const HEADER_CART_INDICATION_MODE = 'header';

@Component({
    selector: 'add-to-cart-btn',
    templateUrl: './add-to-cart-btn.component.html',
    styleUrls: ['./add-to-cart-btn.component.scss'],
    standalone: false
})
export class AddToCartBtnComponent implements  OnInit{

    @Output() action = new EventEmitter();
    @Input() addToCartText: string = 'Add to Cart';
    @Input() disabled: boolean = false;
    @Input() quickBuy: boolean = false;
    @Input() redirectText: string = 'View shopping cart';
    @Input() continueText: string = 'Continue shopping';
    processing$: Observable<boolean>;
    processing = false;
    addToCartOpenModal$: Observable<boolean>;
    redirectLink$: Observable<boolean>;
    skipModalAfterAddToCart$: Observable<boolean>;
    addToCartError$: Observable<string>;
    openModalSub: Subscription;
    processingSub: Subscription;
    redirectLinkSub: Subscription;
    unCommerceApp: boolean = GenericConfig.unCommerceApp || false;
    cartIndicationSettings;
    type = null;

    constructor(protected store$: Store<any>,
                public dialog: MatDialog,
                protected eventBusService: EventBusService,
                protected router: Router) {
        this.processing$ = this.store$.select(getProcessingAddToCart);
        this.addToCartOpenModal$ = this.store$.select(getAddToCartOpenModal);
        this.redirectLink$ = this.store$.select(getRedirectLink);
        this.skipModalAfterAddToCart$ = this.store$.select(getSkipModalAfterAddToCart);
        this.addToCartError$ = this.store$.select(getAddToCartError);
        this.cartIndicationSettings = GenericConfig.cartIndication || {};
    }

    ngOnInit() {
        this.addToCartError$.subscribe(error => {
            if(error && this.openModalSub) {
                this.openModalSub.unsubscribe();
            }
        });
    }

    add() {
        this.applyListeners();
        this.action.next(true);
    }

    applyListeners() {
        this.listenOpenModal();
        this.listenInProcess();
    }

    listenOpenModal() {
        this.redirectLinkSub = this.redirectLink$.subscribe(data => {
            if (data)
                this.router.navigate([GenericConfig.orderType == "rfq" ? "/rfq" : "/cart"]).then(() => {
                    const action = CartActions.redirectLinkDone();
                    this.store$.dispatch(action);
                });
        });
        this.skipModalAfterAddToCart$.subscribe(skip => {
            if (skip) {
                return;
            }
            if (this.quickBuy && this.type == 'quickBuy') {
                this.router.navigate([GenericConfig.orderType == "rfq" ? "/rfq" : "/cart"]);
                return;
            }
            this.openModalSub = this.addToCartOpenModal$.subscribe(open => {
                if (open) {
                    if (this.cartIndicationSettings.mode && this.cartIndicationSettings.mode == HEADER_CART_INDICATION_MODE) {
                        this.eventBusService.emit(new EventData(`${EventName.HEADER_ADD_TO_CART_INDICATION}`, true));
                    } else {
                        const initialState = {
                            title: 'The product has been added to your cart',
                            redirectLink: GenericConfig.orderType == "rfq" ? "/rfq" : "/cart",
                            redirectText: this.redirectText,
                            continueText: this.continueText
                        };
                        const dialogRef = this.dialog.open(
                            AddToSuccessModalComponentGeneric,
                            {
                                data: initialState,
                                maxWidth: 'none',
                                maxHeight: 'none',
                                panelClass: 'add-product-dialog'
                            });
                        if(GenericConfig.autoCloseModal) {
                            dialogRef.afterOpened().subscribe(() => {
                                setTimeout(() => {
                                    dialogRef.close();
                                }, GenericConfig.autoCloseModal)
                            })
                        }
                        dialogRef.afterClosed().subscribe(() => {
                            window.scrollTo(0, 0); // Scrolls the window to the top
                        });
                        this.closeModal();
                    }
                } else {
                    if (this.openModalSub) this.openModalSub.unsubscribe();
                }
            });
        }).unsubscribe();
    }

    listenInProcess() {
        this.processingSub = this.processing$.subscribe(processing => {
            this.processing = processing;
            if (this.processingSub && !processing) this.processingSub.unsubscribe();
        });
    }


    closeModal() {
        const action = CartActions.addToCartCloseModal();
        this.store$.dispatch(action);
    }
}
